import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setAccent } from '@theonefamily/ui';
import App from './App';
import './globals.css';

// AI Studio accent: indigo #6366f1
setAccent('#6366f1');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
